/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {RemoveActiveGoalRequest} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'
import {RemoveActiveGoalResponse} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'


export const removeActiveGoalPiggybankService = (request: RemoveActiveGoalRequest, options?: CashRequestOptions) => post<RemoveActiveGoalRequest, RemoveActiveGoalResponse>("/2.0/cash/remove-active-goal-piggybank-service", request, {...options, rejectOnError: true })